<span class="text-icon" [style.color]="color()">{{ text() }}</span>
